export default __webpack_public_path__ + "static/media/fireship.475b2805.png";